// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD9yKgqXY0RhwgDKwYv3pswhcAIwf1Ja38",
  authDomain: "your-property-guys.firebaseapp.com",
  projectId: "your-property-guys",
  storageBucket: "your-property-guys.firebasestorage.app",
  messagingSenderId: "415384893298",
  appId: "1:415384893298:web:5fcfcdb75935a3ca7d4feb",
  measurementId: "G-JR4GZQL26C",
};

const app = initializeApp(firebaseConfig);

let analytics;
if (typeof window !== "undefined") {
  isSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app);
  });
}

export { app, analytics };